import './CasePage.scss';

import React from 'react';
import { dictionariesSelector } from 'store';
import { generatePath } from 'react-router-dom';
import { IconOpenInNew } from '@dataartdev/uikit/IconOpenInNew';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';
import { useIntl } from 'react-intl';
import { PATH } from '../../../router';
import { EssenceCard } from '../../../common/components/EssenceCard/EssenceCard';
import { cnBlogSingle } from '../../blog/pages';
import { Typography } from '@dataartdev/uikit/Typography';
import { useSelector } from 'react-redux';
import { ICasePage } from './models/CasePage.props';

interface Props {
  landing: ICasePage['landing'] | undefined;
  blog: ICasePage['companyBlogPost'] | undefined;
  webSitesLinks: ICasePage['linkedWebcites'] | undefined;
}

export const CSRightSideGeneration: React.FC<Props> = props => {
  const { locale } = useIntl();
  const { landing, blog, webSitesLinks } = props || {};
  const cards = [landing, blog].filter(Boolean);

  const {
    companySiteCaseStudy: {
      companySiteCaseStudySideLandingLink = '',
      companySiteCaseStudySidePostLink = '',
      companySiteCaseStudyMoreCases = '',
    } = {},
  } = useSelector(dictionariesSelector) || {};

  const generateParams = (options: any) => {
    switch (options.contentType) {
      case 0:
        return {
          ...options,
          contentType: options.contentType,
          picture: options.picture,
          title: options.title,
          view: 'feed',
          size: 'm',
          path: generatePath(PATH.BLOG_SINGLE, {
            slug: options.slug,
            lang: locale === 'en' ? undefined : locale,
          }),
          linkTitle: options.title,
          // linkTitleType1,
          url: options.url || options.fullUrl,
          videoUrl: options.videoUrl,
          video: options.video,
          postDate: null,
          descriptionSmall: companySiteCaseStudySidePostLink,
        };

      case 2:
        return {
          ...options,
          contentType: options.contentType,
          picture: options.picture,
          title: options.title,
          view: 'feed',
          size: 'm',
          linkTitle: options.title || 'watch on youtube',
          url: options.url,
          videoUrl: options.videoUrl,
          video: options.video,
          postDate: null,
        };

      case 3:
        return {
          ...options,
          routePath: generatePath(PATH.EVENTS_PAGE, {
            slug: options.slug,
            lang: locale === 'en' ? undefined : locale,
          }),
        };

      case 4:
        return {
          ...options,
          contentType: options.contentType,
          picture: options.picture,
          routePath: options.link,
          targetBlank: options.targetBlank,
          title: options.title,
          view: 'feed',
          size: 'm',
          linkIcon: IconArrowRight,
          // linkTitle: options.linkTitle,
          redirectTo: options.link,
          text: null,
          linkTitle: companySiteCaseStudySideLandingLink,
        };

      case 5:
        return {
          ...options,
          view: 'feed',
          size: 'm',
          linkTitle: 'learn more',
          path: generatePath(PATH.NEWSROOM_PAGE, {
            slug: options.slug,
            parentSlug: options.parentSlug,
            lang: locale === 'en' ? undefined : locale,
          }),
        };

      case 6:
        return {
          ...options,
          view: 'feed',
          size: 'm',
          linkTitle: 'learn more',
          linkIcon: IconOpenInNew,
          path: generatePath(PATH.INDUSTRIES_PAGE_INNER, {
            slug: options.industrySlug,
            inner_page: options.slug,
            lang: locale === 'en' ? undefined : locale,
          }),
        };

      case 8:
        return {
          ...options,
          path: generatePath(PATH.NEWSROOM_PAGE, {
            slug: options.slug,
            parentSlug: options.parentSlug,
            lang: locale === 'en' ? undefined : locale,
          }),
        };

      default:
        return {
          ...options,
        };
    }
  };

  return (
    <>
      {cards?.map((item: any) => (
        <EssenceCard {...generateParams(item)} />
      ))}
      {webSitesLinks && webSitesLinks.length > 0 && (
        <div className={cnBlogSingle('Recommendation')}>
          <div className={cnBlogSingle('recommendationTitle')}>
            <Typography.Text size="xs" transform="uppercase" weight="bold">
              {companySiteCaseStudyMoreCases}
            </Typography.Text>
          </div>
          <div className={cnBlogSingle('RecommendationList')}>
            {webSitesLinks.map(site => (
              <Typography.Title
                size="tiny"
                key={site.id}
                as="a"
                href={site.link}
                // to={generatePath(PATH.BLOG_SINGLE, {
                //   slug: post.slug,
                //   lang: locale === 'en' ? null : locale,
                // })}
              >
                {site.title}
              </Typography.Title>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
